// extracted by mini-css-extract-plugin
module.exports = {"playerWrapper":"sundayskyvideo_playerWrapper__0bwBI","elementWrapper":"sundayskyvideo_elementWrapper__dEPef"};